export const CTX_SUBSCRIBE_TAGNAME = 'subscribeTagName';
export const CTX_OBSERVE = 'observe';
export const CTX_VALUE = 'value';
export const CTX_ALERT = 'alert';
export const CTX_UNOBSERVE = 'unobserve';
export const CTX_PROVIDE = 'provide';
export const CTX_REVOKE = 'revoke';
